import { Role } from '../../types/type';

// Значения карточки профиля, из которых собирается PUT /profiles/:id
export interface IProfileForm {
  login: string;
  firstName: string;
  middleName: string;
  lastName: string;
  phone: string;
  email: string;
  address: string;
  password: string;
  role: Role;
  status: boolean;
}

// Тело PUT /profiles/:id
export interface IProfileUpdate {
  login: string;
  firstName: string;
  middleName: string;
  lastName: string;
  phoneNumber: string;
  role: Role;
  status: boolean;
  email?: string;
  address?: string;
  password?: string;
}

// userRole — роль, с которой профиль сохранён: пароль водителю не меняем
export function buildProfileUpdate(form: IProfileForm, userRole: Role): IProfileUpdate {
  const email = form.email.trim();
  const address = form.address.trim();
  return {
    login: form.login,
    firstName: form.firstName.trim(),
    // Отчество — отдельное поле, "" его очищает
    middleName: form.middleName.trim(),
    lastName: form.lastName.trim(),
    phoneNumber: form.phone,
    role: form.role,
    status: form.status,
    // Пустые емейл и город не отправляем: "" стёр бы значение
    ...(email ? { email } : {}),
    ...(address ? { address } : {}),
    // Пустой пароль не отправляем: бэкенд сохранил бы пустую строку
    ...(userRole !== 'driver' && form.password ? { password: form.password } : {}),
  };
}
